import { Reducer } from 'redux'
import { IUserState } from 'store/states/user.state'
import { userInitialState } from 'models/user.model'
import * as fromActions from '../actions/user.action'

export const initialState: IUserState = {
  user: userInitialState,
  list: {
    data: [],
    total: 0,
    perPage: 0,
    loading: false,
  },
}
export const reducer: Reducer<IUserState, fromActions.ReducerActions> = (
  state: IUserState = initialState,
  action
) => {
  switch (action.type) {
    case fromActions.USER_UPLOAD:
      return {
        ...state,
        loading: true,
      }
    case fromActions.UPDATE_USER_DATA: {
      const { payload } = action
      return {
        ...state,
        user: payload,
        loading: false,
      }
    }
    case fromActions.SEARCH_USER_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
        },
      }
    case fromActions.SEARCH_USER_LIST_SUCCESS: {
      const { payload } = action
      const { data, perPage, total } = payload
      return {
        ...state,
        list: {
          ...state.list,
          data: data,
          total: total,
          perPage: perPage,
          loading: false,
        },
      }
    }
    default:
      return state
  }
}
